/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Forced_Subtitle_LabelInputs */



/**
* | output |
* | --- |
* | "Forced Subtitle" |
*
* @param {Style_Guide_Manager_Forced_Subtitle_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_forced_subtitle_label = /** @type {((inputs?: Style_Guide_Manager_Forced_Subtitle_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Forced_Subtitle_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titre force")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erzwungener Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli forzati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принудительные субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulo forzado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("强制字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("強制字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनिवार्य उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legenda forçada")
	return /** @type {LocalizedString} */ ("Forced Subtitle")
});